module.exports = __webpack_public_path__ + "img/215.72f35202.jpg";